import type { PayloadAction } from "@reduxjs/toolkit";
import { containerReducers } from "./container";
import { uiReducers } from "./ui";
import { getTotalStudents } from "./classroom";

/**
 * containerSlice spreads its reducer map from roomSlice / classroomSlice (plain
 * object spreads), which strips RTK's payload-type inference and leaves each
 * action creator typed as `() => Action` with `payload: never`. Cast the map
 * once here to a permissive action-creator shape so callers can dispatch with
 * a payload without per-call `as any` workarounds. The runtime values are
 * unchanged — this is only a type-system fix.
 */
type ContainerActionCreators = {
  [K in keyof typeof containerReducers]: ((payload?: any) => PayloadAction<any>) & { type: string };
};

const ReducersIndex = {
  container: containerReducers as unknown as ContainerActionCreators,
  uiReducers: uiReducers,
};

/**
 * Redux getters index - exports all selector functions
 */
export const GettersIndex = {
  getTotalStudents
};

export default ReducersIndex;
